import { CommonLaboratoryResponse, EnumResponse } from '@/api/services/common.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { CommonPatientResponse } from '@/api/services/common/patient/common-patient.dto'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { CommonRegimeResponse } from '@/api/services/common/case/common-case.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'

export enum BillableDeliveryNoteStatus {
    GENERATED = 'GENERATED',
    ISSUED = 'ISSUED',
    VERIFIED = 'VERIFIED'
}
export interface BillableDeliveryNoteStatusEnumResponse extends EnumResponse {
    code: BillableDeliveryNoteStatus
}

export interface BillableDeliveryNoteResponse {
    id: number
    laboratory: CommonLaboratoryResponse
    label: string
    customer: StrictNullable<CustomerResponse>
    patient: StrictNullable<CommonPatientResponse>
    caseType: StrictNullable<CommonCaseTypeResponse>
    regime: StrictNullable<CommonRegimeResponse>
    status: BillableDeliveryNoteStatusEnumResponse
    generationDate: string
    generator: CommonPersonnelResponse
    issueDate: StrictNullable<string>
    issuer: StrictNullable<CommonPersonnelResponse>
    verificationDate: StrictNullable<string>
    verifier: StrictNullable<CommonPersonnelResponse>
    invoice: StrictNullable<InvoiceResponse>
    isForAutoInvoice: boolean
    conceptsTotalValue: StrictNullable<number>
    conceptsAccountingUnit: StrictNullable<AccountingUnitResponse>
    numberOfconcepts: number
    numberOfConceptsWithError: number
    externalReference: StrictNullable<string>
}

export interface BillableDeliveryNotePatchRequest {
    id: number
    externalReference?: string
}
